import React from "react";
import PageWrapper from "./PageHelpers/PageWrapper";
import pageKeys from "../constants/pageKeys";
import { useSelector } from "react-redux";
import RichText from "../../lib/components/RichText";
import { useDocumentTitle } from "../../lib/a11y/useDocumentTitle";


const PageStart = ({setCurrentPage}) => {
    // Der Starttext gehoert der Job-Matrix (#218), nicht der Messe.
    const text = useSelector(state => state.questionnaire.text)
    const eventName = useSelector(state => state.event.name)
    const matrixName = useSelector(state => state.questionnaire.name)
    useDocumentTitle(`${matrixName} – ${eventName}`)

    return (
        <PageWrapper displayFooter={true} className="page-start">
            {text && <RichText
                className="jm-event-descrtiption jm-editor-text jm-content-dark"
                html={text}
            />}

            {/* Echter Knopf und echter Link statt div onClick (#178): fokussierbar,
                mit Namen, per Tastatur bedienbar. Klassen bleiben fuer das Aussehen. */}
            <button
              type="button"
              className="jm-action-button jm-start-button jm-arrow-right"
              onClick={() => setCurrentPage(pageKeys.QUESTIONS)}
            >
                Start
            </button>

            <a className="jm-start-login" href="/wp-login.php">
              zum Aussteller-Login
            </a>
        </PageWrapper>
    )
}

export default PageStart
